export default "__VITE_ASSET__DwUVfqC3__"